import { useEffect, useRef, useState } from 'react';
import { fmt } from '../utils';
import Preview from './Preview';

const useCountUp = (value) => {
  const [shown, setShown] = useState(value);
  const raf = useRef();
  useEffect(() => {
    const from = shown;
    const to = value;
    if (from === to) return;
    const start = performance.now();
    const dur = 450;
    cancelAnimationFrame(raf.current);
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setShown(Math.round(from + (to - from) * eased));
      if (p < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return shown;
};

export const Ledger = ({ build }) => (
  <div>
    {build.lines.map((l) => (
      <div key={l.name} className="line fadein">
        <span className="text-gray-100">
          {l.name}
          {l.sub && <span className="block text-xs text-gray">{l.sub}</span>}
        </span>
        <span className="tabular whitespace-nowrap font-semibold">
          {l.price === 0 ? (
            <>
              {l.market && <span className="mr-1.5 text-xs font-normal text-gray line-through">₹{fmt(l.market)}</span>}
              <span className="text-[#1d9c5e]">Free</span>
            </>
          ) : (
            `₹${fmt(l.price)}`
          )}
        </span>
      </div>
    ))}
    {build.discounts.length > 0 && (<>
    <div className="line fadein">
      <span className="text-gray">Subtotal</span>
      <span className="tabular whitespace-nowrap font-semibold">₹{fmt(build.subtotal)}</span>
    </div>
    {build.discounts && build.discounts.map((d) => (
      <div key={d.label} className="line fadein">
        <span className="font-medium text-[#1d9c5e]">
          {d.label}
          <span className="block font-normal text-xs text-gray">{d.sub}</span>
        </span>
        <span className="tabular whitespace-nowrap font-semibold text-[#1d9c5e]">-₹{fmt(d.amount)}</span>
      </div>
    ))}
    </>)}
  </div>
);

export const Total = ({ build, size = 'text-4xl' }) => {
  const shown = useCountUp(build.total);
  return (
    <span className={`tabular font-semibold leading-none ${size}`}>
      <span className="mr-1 text-base font-medium text-gray">₹</span>
      {fmt(shown)}
    </span>
  );
};

/* Desktop sticky product panel: the thing you're building, its price, one button. */
const ProductPanel = ({ build }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="sticky top-24">
      <Preview build={build} />
      <div className="mt-6 flex items-end justify-between">
        <div>
          <p className="text-xs text-gray">{build.deliveryText}</p>
          <Total build={build} />
        </div>
        <button type="button" onClick={() => setOpen((o) => !o)} className="text-xs text-blue hover:underline">
          {open ? 'Hide summary' : 'Summary'}
        </button>
      </div>
      <div className="overflow-hidden transition-[max-height] duration-500" style={{ maxHeight: open ? 480 : 0 }}>
        <div className="mt-4 rounded-2xl border border-[#E2E8F0] px-4 py-1">
          <Ledger build={build} />
        </div>
      </div>
      <a href={build.waHref} target="_blank" rel="noopener noreferrer" className="btn-wa mt-5 w-full !py-3.5 !text-base">
        Order on WhatsApp
      </a>
    </div>
  );
};

export default ProductPanel;
